export const HEADING_TEXT = 'Our payment processor needs more information to verify your identity.';
export const TEXT_CONTENT = 'Please answer four knowledge-based questions. You will have two minutes to do so.';
